import utils from '../SPCUtils';

var mContainer = null;

const mMarkers = [];
const mMobiles = {}
const mTopNavigation = {};

const add_marker = (el) => {
	// console.info("Adding marker", el);
	mMarkers.push(el);
}

const add_mobile = (el, values) => {
	const container_name = values.container;

	if (container_name) {
		if (!mMobiles[container_name]) {
			mMobiles[container_name] = [];
		}

		mMobiles[container_name].push(el);
	}
}

const add_top_navigation = (el, values) => {
	const container_value = values.container;

	if (container_value) {
		const values_container = container_value.split(',');

		for (var i = 0; i < values_container.length; i++) {
			const container_name = values_container[i].trim();

			if (!mTopNavigation[container_name]) {
				mTopNavigation[container_name] = [];
			}

			mTopNavigation[container_name].push(el);
		}
	}
}

const hide_all_mobiles = () => {
	for (var key in mMobiles) {
		const mobile = mMobiles[key];

		for (var i = 0; i < mobile.length; i++) {
			utils.addClassIfNotExists(mobile[i], 'hide');
		}
	}
}

const hide_all_top_navigation = () => {
	for (var key in mTopNavigation) {
		const topNavigation = mTopNavigation[key];

		if (topNavigation) {
			for (var i = 0; i < topNavigation.length; i++) {
				utils.removeClassIfExists(topNavigation[i], 'active');
			}
		}
	}
}

const hide_container = () => {
	if (mContainer) {
		utils.addClassIfNotExists(mContainer, 'hide');
	}
}

const show_container = () => {
	if (mContainer) {
		utils.removeClassIfExists(mContainer, 'hide');
	}
}

const find_elements = () => {
	const result = [];

	const viewport_y = window.scrollY;
	const viewport_height = window.innerHeight;
	const viewport_bottom = viewport_y + viewport_height;

	for (var i = 0; i < mMarkers.length; i++) {
		const marker = mMarkers[i];

		if (!marker) {
			continue;
		}

		const element_position = utils.calculateElementPosition(marker);
		const element_box = utils.toRect(element_position);

		const element_top = element_box.top;
		const element_bottom = element_box.bottom;
		const actual_size = viewport_y - (element_bottom);

		if (element_top > viewport_bottom) {
			continue;
		}

		if (element_box.bottom <= 0) {
			continue;
		}

		if (actual_size > viewport_bottom) {
			continue;
		}

		result.push({ size: actual_size, marker: marker });
	}

	return result;
}

const find_elements_by_id = (id) => {
	const result = [];

	for (var i = 0; i < mMarkers.length; i++) {
		const marker = mMarkers[i];

		if (marker.id == id) {
			result.push(marker);
		}
	}

	return result;
}

const highlight_selected_element = (elements) => {
	let  selected_element = null;

	if (elements.length == 0) {
		hide_container();
	} else {
		const valid_elements = elements.sort((f, s) => { return f.size > s.size ? f : s; });
		selected_element = valid_elements[0].marker;
	}

	if (!selected_element) {
		hide_container();
	} else {
		hide_all_mobiles();
		hide_all_top_navigation();
		show_container();

		const mobile = mMobiles[selected_element.id];
		const topNavigation = mTopNavigation[selected_element.id];

		if (mobile) {
			for (var k = 0; k < mobile.length; k++) {
				utils.removeClassIfExists(mobile[k], 'hide');
			}
		} else {
			// console.error('No mobile for', selected_element.id);
		}

		if (topNavigation) {
			
			for (var q = 0; q < topNavigation.length; q++) {
				utils.addClassIfNotExists(topNavigation[q], 'active');
			}
		}
	}
}

const check = () => {
	// Check for footer
	utils.removeClassIfExists(mContainer, 'hide');

	const filtered_elements = find_elements();

	highlight_selected_element(filtered_elements)	
};

const delayed_check = () => {
	setTimeout(() => { check(); }, 100);
}

const install = (vue) => {
	window.addEventListener('scroll', delayed_check);
	delayed_check();

	vue.directive('scroll-marker', {
		bind(el) {
			add_marker(el);
		}
	});

	vue.directive('scroll-mobile', {
		bind(el, binding) {
			add_mobile(el, binding.value);
		}
	});

	vue.directive('scroll-top-navigation', {
		bind(el, binding) {
			add_top_navigation(el, binding.value);
		}
	});

	vue.directive('scroll-mobile-container', {
		bind(el) {
			mContainer = el;
		}
	});

	vue.directive('scroll-footer', {
		bind() {
		}
	});

	vue.directive('send-to-top', {
		bind() {
			console.log('CHegou aqui');
			window.scrollTo(0, 0);
		}
	});

	vue.prototype.$update_current_page = function(data) {
		highlight_selected_element(find_elements_by_id(data.id));
	}
};

export default install;